import {Component, Input} from '@angular/core';
import {ElementUszkodzenia} from '../../../../../../../../../services/slownik/types/element-uszkodzenia';
import {LokalizacjaUszkodzenia} from '../../../../../../../../../model/uszkodzenia/lokalizacja-uszkodzenia';

@Component({
  selector: 'shared-selektor-lokalizacja',
  templateUrl: './selektor-lokalizacja.component.html'
})

export class SelektorLokalizacjaComponent {

  @Input()
  uszkodzenia!: ElementUszkodzenia[] | undefined

  @Input()
  nazwaLokalizacji!: string

  wybierzObrazDlaLokalizacji(): string | undefined {
    return LokalizacjaUszkodzenia.pobierz(this.nazwaLokalizacji)?.obraz
  }
}
